import { Collapsible } from '../interfaces';

export class ComparabilitySearchInitialRange implements Collapsible {
  numYearsOfData: number;
  averagingMethodology: string;
  statisticalMethodology: string;
  inRangeStatus: string;
  numCompsRemainingAfterBulk: number;
  numCompsRemainingAfterFine: number;
  collapsed: boolean;
}
